import axios from 'axios'
import api from './api'
import Vue from 'vue';
let Base64 = require('js-base64').Base64;
import { Toast } from 'vant';
import qs from "qs";
import { backendLangFrom, normalizeLocale } from '@/common/locale';

Vue.use(Toast);
//创建axios实例对象
const  instance = axios.create({
    // baseURL: 'https://adminmanage.l-o-v-e.homes/api', //服务器地址
     baseURL: '/api', //服务器地址
    timeout: 5000, //默认超时时长
    withCredentials: true, 
})

//请求拦截器
// map UI locale (what vue-i18n uses) to the backend's lang file names
function backendLang(){
    return backendLangFrom(normalizeLocale(localStorage.getItem('lang') || 'en'));
}
instance.interceptors.request.use(config=>{
    // KissMora: drive the global top progress bar
    if(typeof window !== 'undefined' && window.$km && window.$km.loader){
        try { window.$km.loader.start(); } catch(e){ /* ignore */ }
    }
    if(config.method === "post"){
        config.headers = {
            'content-type': 'application/x-www-form-urlencoded;charset=UTF-8', // 设置跨域头部
        }
    }
    const bl = backendLang();
    // ThinkPHP Lang::detect() reads $_GET['lang'] and cookie 'think_lang' — set both so backend lang() matches UI locale.
    document.cookie = 'think_lang=' + bl + '; path=/';
    config.params = { ...(config.params || {}), lang: bl };
    config.headers = {
        ...config.headers,
        'lang': bl,
        'think-lang': bl,
    };
    if(localStorage.getItem('token')){
        config.headers = {
            ...config.headers,
            'token': Base64.encode(localStorage.getItem('token')),
        }
    }
    return config
},err=>{
    console.error('Request failed', err)
})

//响应拦截器
function _kmLoaderDone(){
    if(typeof window !== 'undefined' && window.$km && window.$km.loader){
        try { window.$km.loader.done(); } catch(e){ /* ignore */ }
    }
}
instance.interceptors.response.use(res=>{
    _kmLoaderDone();
    //此处对响应数据做处理
    if(res.data.msg === "Authentication error!"){
        // localStorage.clear();
        // this.$router.push({path:'/Login'})
    }
    return res //该返回对象会传到请求方法的响应对象中
},err=>{
    _kmLoaderDone();
    // 响应错误处理
    return Promise.reject(err);
})

// KissMora: UTF-8 safe base64 → string → JSON parser.
// The backend base64-encodes a UTF-8 JSON string. js-base64's .decode() is
// already UTF-8 aware, but we add a hardened fallback so multi-byte chars
// (emojis etc.) never get mis-interpreted as Latin-1.
function safeJsonFromB64(b64){
    if(typeof b64 !== 'string' || !b64) return null;
    try { return JSON.parse(Base64.decode(b64)); } catch(e){ /* try fallback */ }
    try {
        var bin = atob(b64);
        var bytes = new Uint8Array(bin.length);
        for(var i = 0; i < bin.length; i++) bytes[i] = bin.charCodeAt(i);
        return JSON.parse(new TextDecoder('utf-8').decode(bytes));
    } catch(e){ return null; }
}

//封装axios请求方法，参数为配置对象
//option = {method,url,params} method为请求方法，url为请求接口，params为请求参数

function kmMaybeForcePassword(result){
    try {
        if (result && Number(result.code) === 423) {
            localStorage.setItem('must_change_password', '1');
            if (window.location.hash.indexOf('SetLoginPassword') === -1) {
                window.location.hash = '#/SetLoginPassword?force=1';
            }
        }
        if (result && result.data && Number(result.data.must_change_password) === 1) {
            localStorage.setItem('must_change_password', '1');
        }
    } catch (e) { /* ignore */ }
    return result;
}

async function http(option = {}) {
    let result = null
    if(option.method === 'get' || option.method === 'delete'){
        //处理get、delete请求
        await instance[option.method](
            api[option.url],
            {params: option.data}
        ).then(res=>{
            result = res.data
            result.data = safeJsonFromB64(result.data);
            kmMaybeForcePassword(result);
        }).catch(err=>{
            result = err
        })
    }else if(option.method === 'post' || option.method === 'put'){
        //处理post、put请求
        await instance[option.method](
                api[option.url],
            qs.stringify(option.data)
        ).then(res=>{
            result = res.data;
            result.data = safeJsonFromB64(result.data);
            kmMaybeForcePassword(result);
        }).catch(err=>{
            result = err
        })
    }
    return result
}

export default http

